import { useEffect } from "react";

// TODO: duplicate with react-router-dom v6, remove after upgrade
export function useBeforeUnload(
  cb: (event: BeforeUnloadEvent) => any,
  options?: { capture?: boolean },
) {
  const { capture } = options || {};

  useEffect(() => {
    const opts = capture ? { capture } : undefined;
    window.addEventListener("beforeunload", cb, opts);
    return () => {
      window.removeEventListener("beforeunload", cb, opts);
    };
  }, [cb, capture]);
}
